// @ts-nocheck

export const getSignalrEventType = (type, msg = {}) => {
  if (msg.messageId) {
    return `SIGNALR_INCOME/${type}/${msg.messageId}`;
  }
  return `SIGNALR_INCOME/${type}`;
};

export const SIGNALR_TYPE = 'SIGNALR';
export const SIGNALR_START_TYPE = 'SIGNALR_START';
export const SIGNALR_CONNECTED_TYPE = 'CONNECTED';
export const SIGNALR_INVOKE_TYPE = 'SIGNALR_INVOKE';
export const SIGNALR_HUB_EXTEND_TYPE = 'SIGNALR_HUB_EXTEND';
export const SIGNALR_STOP_TYPE = 'SIGNALR_STOP';

export const actionSignalRConnectionStart = ({ hub, hubEvents, subscribeId, invokeType, data, url }) => ({
  type: SIGNALR_START_TYPE,
  hub,
  hubEvents,
  subscribeId,
  invokeType,
  data,
  url,
});
export const actionSignalRConnectionInvoke = ({ hub, invokeType, subscribeId, data }) => ({
  type: SIGNALR_INVOKE_TYPE,
  hub,
  subscribeId,
  invokeType,
  data,
});
export const actionSignalRConnectionStop = ({ hub, subscribeId, data, invokeType }) => ({
  type: SIGNALR_STOP_TYPE,
  hub,
  subscribeId,
  data,
  invokeType,
});
